import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { TraineeEvaluationDto } from "../../../types/applicationTypes";
import { Mail } from "@mui/icons-material";
import SelectionTable from "./SelectionTable";

/**
 * The ApplicantSelectionProps interface defines the props for the ApplicantSelection component
 */
interface ApplicantSelectionProps {
  applicantsEvaluations: TraineeEvaluationDto[];
  selectedApplicants: TraineeEvaluationDto[];
  setSelectedApplicants: React.Dispatch<React.SetStateAction<TraineeEvaluationDto[]>>;
  handleInviteApplicants: () => void;
}

/**
 * The ApplicantSelection component displays a table with all applicants and the possibility to select them for the selection weekend
 * @param applicantsEvaluations The evaluations of the applicants
 * @param selectedApplicants The selected applicants
 * @param setSelectedApplicants The function to set the selected applicants
 * @param handleInviteApplicants The function to invite the selected applicants
 * @returns The ApplicantSelection component
 */
const ApplicantSelection = ({
  applicantsEvaluations,
  selectedApplicants,
  setSelectedApplicants,
  handleInviteApplicants,
}: ApplicantSelectionProps) => {
  return (
    <Stack spacing={2}>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
        <Typography variant="h6" fontWeight={"bold"}>
          Bewerberauswahl
        </Typography>
        <Button variant="contained" size="small" onClick={handleInviteApplicants}>
          <Mail sx={{ mr: 2 }} />
          Einladungen abschicken
        </Button>
      </Stack>
      <Typography>
        Bitte wähle die Bewerber aus, die du zum Auswahlwochenende einladen möchtest. Alle Änderungen werden{" "}
        <strong>sofort gespeichert</strong>.
        <br />
        Wenn du fertig bist, kannst du mit den obigen Buttons eine PDF-Datei zum Ausdrucken aller eingeladenen Bewerber
        (für das Auswahlwochenende) erstellen und eine Mail an alle ausgewählten Bewerber schicken.
        <br />
        <br />
        <strong>Wichtig:</strong> Alle Bewerber sollten von allen Bewertern bewertet worden sein. Da sich die
        Gesamtbewertung als Summe berechnet, hätte ein Bewerber sonst weniger Punkte.
        <br />
        <br />
        Es wurden {selectedApplicants.length} von {applicantsEvaluations.length} Bewerbern ausgewählt. Weitere{" "}
        {applicantsEvaluations.filter((applicant) => applicant.invited).length} Bewerber wurden bereits eingeladen.
      </Typography>
      <SelectionTable
        applicantsEvaluations={applicantsEvaluations}
        selectedApplicants={selectedApplicants}
        setSelectedApplicants={setSelectedApplicants}
        tableType="invite"
      />
    </Stack>
  );
};

export default ApplicantSelection;
